module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-level"
  }, [_c('form', {
    attrs: {
      "name": "contact",
      "netlify": ""
    }
  }, [_c('p', [_c('label', [_vm._v("Your Name: "), _c('input', {
    attrs: {
      "type": "text",
      "name": "name"
    }
  })])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("Your Email: "), _c('input', {
    attrs: {
      "type": "email",
      "name": "email"
    }
  })])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("Message: "), _c('textarea', {
    attrs: {
      "name": "message"
    }
  })])]), _vm._v(" "), _c('p', [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6839a7dd"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Submission.vue
// module id = 1081
// module chunks = 1